import { Component, EventEmitter, input, Input, output, Output } from '@angular/core';
import { Types } from 'shared-lib';
import { EComponentSize, EIcon } from '../../types';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { helper } from '../../../public-api';
@Component({
  selector: 'ui-button',
  standalone: true,
  imports: [IconComponent, CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  type = input<Types.EAlert>(Types.EAlert.INFO);
  text = input<string>();
  disabled = input(false);
  iconFIll = input(false);
  size = input<EComponentSize>(EComponentSize.Medium);
  icon = input<EIcon>();

  action = output<Event>();

  iconTypes = EIcon;

  darkMode = false;
  
  ngOnInit(): void {
    this.darkMode = helper.Functions.isDarkMode();
    if (!this.text && !this.icon) {
      throw new Error(`O botão deve ter pelo menos um ícone ou texto.`);
    }
  }

  get buttonClass(): string {
    const baseClass = `font-medium text-base shadow-md transition-all duration-300 ease-in-out active:scale-95`;
    const disabledClass = this.disabled() ? 'opacity-50 cursor-not-allowed' : '';
    const buttonSize = this.getSize();
    if (!this.text() && this.icon()) {
      return `${baseClass} ${disabledClass}
        rounded-full p-2 w-10 h-10 flex items-center justify-center
        bg-transparent border-0 shadow-none
        transform-gpu will-change-transform
        hover:scale-110 hover:bg-transparent hover:border-0`;
    }
    const getColorClass = (type: Types.EAlert): string => {
      switch (type) {
        case Types.EAlert.INFO:
          return 'bg-blue-500 text-white border-blue-500 hover:bg-blue-600';
        case Types.EAlert.DANGER:
          return 'bg-red-500 text-white border-red-500 hover:bg-red-600';
        case Types.EAlert.SUCCESS:
          return 'bg-green-500 text-white border-green-500 hover:bg-green-600';
        case Types.EAlert.WARNING:
          return 'bg-yellow-500 text-black border-yellow-500 hover:bg-yellow-600';
        case Types.EAlert.DARK:
          if (this.darkMode){
            return 'bg-white text-black border-gray-300 hover:bg-gray-100';
          }else{
            return 'bg-gray-800 text-white border-gray-800 hover:bg-gray-900';
          }
        default:
          return 'bg-gray-500 text-white border-gray-500 hover:bg-gray-600';
      }
    };
    
    const colorClass = getColorClass(this.type());

    const roundClass = 'rounded-lg px-6 py-2';

    return `${baseClass} ${colorClass} ${disabledClass} ${buttonSize} ${roundClass}`;
  }

  getSize(): string {
    const sizeClasses: Record<EComponentSize, string> = {
      [EComponentSize.Small]: 'px-3 py-1 text-sm',
      [EComponentSize.Medium]: 'px-4 py-2 text-base',
      [EComponentSize.Large]: 'px-6 py-3 text-lg',
      [EComponentSize.ExtraLarge]: 'px-8 py-4 text-xl',
    };

    return sizeClasses[this.size()] || '';
  }

  getIconColor(): Types.EAlert {
    if (this.text()){
      switch (this.type()) {
        case Types.EAlert.INFO:
        case Types.EAlert.SUCCESS:
          return Types.EAlert.LIGHT;
        case Types.EAlert.LIGHT:
          return Types.EAlert.DARK;
        case Types.EAlert.DANGER:
          return Types.EAlert.WARNING;
        default:
          return Types.EAlert.INFO;
      }
    }else{
      return this.type();
    }

  }

  handleClick(event: Event) {
    if (!this.disabled()) {
      this.action.emit(event);
    }
  }

}
